export const LIVE_HIGHLIGHT_COLOR = '#F3FF2A';

const HERO_TEXT_DEFAULT = '#000000';

const normalizeHexColor = (value: string | undefined, fallback: string): string => {
  const trimmed = (value ?? '').trim();
  if (!trimmed) return fallback;
  const hex = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  if (/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(hex)) return hex.toUpperCase();
  return fallback;
};

export const resolveHeroBackgroundColor = (backgroundColor?: string): string =>
  normalizeHexColor(backgroundColor, LIVE_HIGHLIGHT_COLOR);

export const resolveHeroTextColor = (textColor?: string): string =>
  normalizeHexColor(textColor, HERO_TEXT_DEFAULT);
